/* eslint-disable linebreak-style */
export default {
  namespaced: true,
  state: () => ({
    editingContact: false,
  }),
  mutations: {
    toggleEditingContact(state) {
      state.editingContact = !state.editingContact;
    },
    setEditingContact(state, value) {
      state.editingContact = value;
    },
  },
};
